<template>
  <!-- Site wrapper -->
  <div class="wrapper">
    <cabecalho tituloPagina="Pedidos" />
    <menuLateral />
    <!-- Content Wrapper. Contains page content -->
    <div class="content-wrapper">
      <!-- Content Header (Page header) -->
      <section class="content-header">
        <div class="container-fluid"></div>
        <!-- /.container-fluid -->
      </section>
      <!-- Main content -->
      <section class="content">
      <!-- Default box -->
      <div class="card">
        <div class="card-body">
          <spinnerProcessando cssClass="ml-2" :status="flagsDeControle.carregandoDados.status" :mensagem="flagsDeControle.carregandoDados.mensagem"/>
          <ListagemPedidos
            :itens="listaFaturas"
            :colunas="fields"
            :estaCarregando="flagsDeControle.carregandoDados.status"
            :modoInline="false"
            :definirClasseLinha="definirClasseLinha"
            @action="encaminharParaPagamento"
            >
            <template #servico="{ item }">
              <router-link class="linkr" :to="{ name: 'faturaDetalhes', params: { id: item.id } }">
                {{ item.descricao }}
              </router-link>
            </template>
            <template #acoes="{ item }">
              <b-button
                v-if="item.status !== 1"
                :class="{
                  'botoes botaoPagamentoFatura': true,
                  'botaoFaturaPaga': item.status === 1,
                  'botaoFaturaPendente': item.status !== 1
                }"
                variant="outline-primary btn-sm"
                @click="encaminharParaPagamento(item.id)"
              >
                Pagar
              </b-button>
            </template>
          </ListagemPedidos>
          <pagination :fonteDeDados="componentePaginacao.fonteDeDados" :disabled="flagsDeControle.carregandoDados.status" @navegarNaPaginacao="obterDadosPaginados"/>
        </div>
      </div>
    </section>
      <!-- /.content -->
    </div>
    <!-- /.content-wrapper -->
  </div>
  <!-- ./wrapper -->
</template>

<script>
import Pedidos from './js'
export default Pedidos
</script>

<style scoped>
@import "./scss/pedidos.scss";
</style>
